import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=543c700f&scoped=true"
import script from "./addOrUpdate.vue?vue&type=script&lang=js"
export * from "./addOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./addOrUpdate.vue?vue&type=style&index=0&id=543c700f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543c700f",
  null
  
)

export default component.exports